import { gql } from '@apollo/client';
import { getProductFragment, queryRequiresZipCode } from '../product/getProductQuery';
import { spreadGroupedDomains } from '../../react/util';

const getIRGQuery = ({ domains: initialDomains = [] }) => {
  const domains = spreadGroupedDomains({ domains: initialDomains });

  const fragments = getProductFragment({ domains });
  const params = ['$itemId: String!', '$storeId: String = "8119"', '$maxItems: Int'];
  if (queryRequiresZipCode({ domains })) {
    params.push('$zipCode: String');
  }

  const MainQuery = gql`
    fragment IRGMainQuery on BundleResponse {
        irg {
            collection(maxItems: $maxItems)  {
                metadata {
                    title
                    modelName
                    fallbackModelName
                    apiName
                    version
                    __typename
                },
                categories {
                    category
                    itemIds
                }
                products {
                    product {
                        ${fragments.query}
                    }

                }
            }
            accessories {
                metadata {
                    title
                    modelName
                    fallbackModelName
                    apiName
                    version
                    __typename
                },
                categories {
                    category
                    itemIds
                }
                products {
                    product {
                        ${fragments.query}
                    }

                }
            }
            coordinatingItems {
                metadata {
                    title
                    modelName
                    fallbackModelName
                    apiName
                    version
                    __typename
                },
                categories {
                    category
                    itemIds
                }
                products {
                    product {
                        ${fragments.query}
                    }
                }
            }
        }
    }
  `;

  const IRGQuery = `
    query IRGQuery(${params.join(', ')}) {
      dynamicRecs(itemId: $itemId, storeId: $storeId) {
        ...IRGMainQuery
        __typename
      }
    }
    ${fragments.fragments}
    ${MainQuery.loc.source.body}
`;

  return gql(IRGQuery);
};

export default getIRGQuery;
